import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import VerticalImages from "../components/VerticalImages";
import Banner from "../components/Banner";
import Partners from "../components/Partners";
import ServicesActivities from "../components/ServicesActivities";
import RegistrationForm from "../components/RegistrationForm";

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#registration-form") {
      const form = document.getElementById("registration-form");
      if (form) {
        setTimeout(() => {
          form.scrollIntoView({ behavior: "smooth" });
        }, 300); // delay nhỏ để đảm bảo trang render xong
      }
    }
  }, [location]);

  return (
    <div className="home-page">
      <Banner />
      <VerticalImages />
      <RegistrationForm />
      <Partners />
      <ServicesActivities />
    </div>
  );
};

export default HomePage;
